import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TVesselInfo, TVesselOngoingVoyageDailySignalsSliceState, VESSEL_ONGOING_VOYAGE_DAILY_SIGNALS, } from '../mapTypes';

const initialState: TVesselOngoingVoyageDailySignalsSliceState = {
    vesselOngoingVoyageDailySignalsData: null,
    vesselOngoingVoyageDailySignalsLoading: false,
    vesselOngoingVoyageDailySignalsError: null,
};

const vesselOngoingVoyageDailySignalsSlice = createSlice({
    name: VESSEL_ONGOING_VOYAGE_DAILY_SIGNALS,
    initialState,
    reducers: {
        emptyVesselOngoingVoyageDailySignalsAction: (state: TVesselOngoingVoyageDailySignalsSliceState) => {
            state.vesselOngoingVoyageDailySignalsData = null;
            state.vesselOngoingVoyageDailySignalsLoading = false;
            state.vesselOngoingVoyageDailySignalsError = null;
        },
        getVesselOngoingVoyageDailySignalsRequestAction: (state: TVesselOngoingVoyageDailySignalsSliceState, _: PayloadAction<{ imoNumbers: number[], date: string }>) => {
            state.vesselOngoingVoyageDailySignalsLoading = true;
            state.vesselOngoingVoyageDailySignalsError = null;
        },
        getVesselOngoingVoyageDailySignalsSuccessAction: (
            state: TVesselOngoingVoyageDailySignalsSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselOngoingVoyageDailySignalsLoading = false;
            state.vesselOngoingVoyageDailySignalsData = data;
            state.vesselOngoingVoyageDailySignalsError = null;
        },
        getVesselOngoingVoyageDailySignalsErrorAction: (
            state: TVesselOngoingVoyageDailySignalsSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselOngoingVoyageDailySignalsData = null;
            state.vesselOngoingVoyageDailySignalsLoading = false;
            state.vesselOngoingVoyageDailySignalsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const {
    emptyVesselOngoingVoyageDailySignalsAction,
    getVesselOngoingVoyageDailySignalsRequestAction,
    getVesselOngoingVoyageDailySignalsSuccessAction,
    getVesselOngoingVoyageDailySignalsErrorAction
} =
    vesselOngoingVoyageDailySignalsSlice.actions;
export default vesselOngoingVoyageDailySignalsSlice.reducer;
